import { transcriptionSettingsSource } from 'app.constants';
const kTranscriptionMfeId = 'transcription-mfe';
const kTranscriptionMfeEl = 'blip-transcription-mfe';
export class TranscriptionMfeService {
    static $inject = ['AuthenticationService', 'TenantService', 'BLIP_AZURE_ISSUER', 'BLIP_ACCOUNT_ISSUER'];
    constructor(AuthenticationService, TenantService, BLIP_AZURE_ISSUER, BLIP_ACCOUNT_ISSUER) {
        this.AuthenticationService = AuthenticationService;
        this.TenantService = TenantService;
        this.BLIP_AZURE_ISSUER = BLIP_AZURE_ISSUER;
        this.BLIP_ACCOUNT_ISSUER = BLIP_ACCOUNT_ISSUER;
    }
    async show({ url, transcriptions, mediaDuration, contactId, extraPayload, }) {
        const agent = this.AuthenticationService.getAccount();
        const props = {
            id: kTranscriptionMfeId,
            language: agent.culture,
            'settings-source': transcriptionSettingsSource,
        };
        if (url) {
            const auth = this.AuthenticationService.auth;
            const currentTenant = this.TenantService.getTenantPrefixFromUrl();
            const oidcData = localStorage.getItem('oidc.azureB2CData');
            const isEnabledBlipLogin = oidcData ? JSON.parse(oidcData).isEnabled : false;
            props['remote-transcription'] = JSON.stringify({
                url,
                tenant: currentTenant ?? '',
                credentials: {
                    identity: agent.identity,
                    token: auth.token,
                    userIdentifier: agent.email,
                    issuer: isEnabledBlipLogin ? this.BLIP_AZURE_ISSUER : this.BLIP_ACCOUNT_ISSUER,
                },
                extraPayload,
                contactId,
            });
        }
        else if (transcriptions) {
            props['local-transcription'] = JSON.stringify({
                transcriptions,
                mediaDuration,
            });
        }
        const body = document.querySelector('body');
        let el = document.getElementById(kTranscriptionMfeId);
        if (!el) {
            el = document.createElement(kTranscriptionMfeEl);
        }
        else {
            el.removeAttribute('remote-transcription');
            el.removeAttribute('local-transcription');
        }
        el.style.zIndex = '99999999';
        el.style.position = 'relative';
        for (const prop of Object.keys(props)) {
            el.setAttribute(prop, props[prop]);
        }
        body.prepend(el);
    }
    async close() {
        const el = document.getElementById(kTranscriptionMfeId);
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }
}
TranscriptionMfeService.$inject = ['AuthenticationService', 'TenantService', 'BLIP_AZURE_ISSUER', 'BLIP_ACCOUNT_ISSUER'];
